"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const SitesList_1 = __importDefault(require("./components/SitesList"));
function SitesView() {
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 4 },
        react_1.default.createElement(Grid_1.default, { xs: 12, item: true },
            react_1.default.createElement(SitesList_1.default, null))));
}
exports.default = SitesView;
